export function setWebicon(icon: string) {
	const link: any = document.querySelector("link[rel*='icon']") || document.createElement('link')
	link.type = 'image/x-icon'
	link.rel = 'shortcut icon'
	link.href = icon //icon图标
	document.getElementsByTagName('head')[0].appendChild(link)
}
